import * as yup from "yup";
export const yupRequired = yup
    .string()
    .nullable()
    .required("This is a required field");
export const requiredString = (fieldLabel = "") => yup.string().nullable().required().label(fieldLabel);
export const yupEmail = yup
    .string()
    .email("Please enter a valid email")
    .required("Email is required");
export const yupFirstName = yup.string().required("First name is required");
export const yupLastName = yup.string().required("Last name is required");
export const yupPassword = yup
    .string()
    .min(6, "Password should have at least 6 characters")
    .required("Password is required");
export const yupPasswordConfirmation = yup
    .string()
    .oneOf([yup.ref("password")], "Passwords do not match")
    .required("Password confirmation is required");
export const yupWebsite = requiredString("Website").matches(/^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/, "Website is not valid");
export const yupChecked = yup
    .boolean()
    .oneOf([true], "You must accept the terms and conditions");
//# sourceMappingURL=validations.js.map